import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './menu-list.less'

interface IMenuItemsProps {
    children: ReactNode; // 用户自定义的菜单内容
    wrapClassName?: string; // 外层容器的自定义类名
    style?: React.CSSProperties; // 按钮样式
}

export default function MenuList({ children, wrapClassName, style }: IMenuItemsProps) {
    return (
        <div
            className={classNames({
                "menu-list": true,
            }, wrapClassName)} style={style}>

            {children}
        </div>
    );
}
